import type { ReactNode } from 'react';
import { sanitizeRichTextDocument, type RichTextLeaf } from '../tier0/kit-richtext.mjs';

function leaf(node: RichTextLeaf): ReactNode {
  let value: ReactNode = node.text;
  for (const mark of node.marks ?? []) {
    if (mark.type === 'bold') value = <strong>{value}</strong>;
    if (mark.type === 'italic') value = <em>{value}</em>;
    if (mark.type === 'code') value = <code>{value}</code>;
    if (mark.type === 'link')
      value = (
        <a href={mark.href} rel="noopener noreferrer">
          {value}
        </a>
      );
  }
  return value;
}
const inline = (content: RichTextLeaf[]) =>
  content.map((node, index) => <span key={index}>{leaf(node)}</span>);

export function RichText({ value }: { value: unknown }) {
  const document = sanitizeRichTextDocument(value);
  return (
    <div className="pc-prose">
      {document.content.map((node, index) => {
        if (node.type === 'paragraph') return <p key={index}>{inline(node.content)}</p>;
        if (node.type === 'heading') {
          if (node.level === 1) return <h1 key={index}>{inline(node.content)}</h1>;
          if (node.level === 2) return <h2 key={index}>{inline(node.content)}</h2>;
          if (node.level === 3) return <h3 key={index}>{inline(node.content)}</h3>;
          return <h4 key={index}>{inline(node.content)}</h4>;
        }
        const Tag = node.ordered ? 'ol' : 'ul';
        return (
          <Tag key={index}>
            {node.content.map((item, position) => (
              <li key={position}>{inline(item.content)}</li>
            ))}
          </Tag>
        );
      })}
    </div>
  );
}
